<template>
  <a
    :href
    :target
  >
    <slot />
  </a>
</template>

<script setup lang="ts">
import type { NuxtLinkProps } from '#app';

// TODO: has to be resolved the same way as NuxtLink
const props = defineProps<NuxtLinkProps>();

// get the href handling for sanity files
const getHref = (): string => {
  const toString = (props.href as string) || (props.to as string);
  if (!toString) {
    console.warn('No href provided to PTCLink', JSON.stringify(props));
    return '';
  }
  if (toString.includes('.sanity.io/')) {
    console.warn('Sanity file URL detected:', toString);
  }
  return toString;
};

const href = getHref();
const target = props.target || undefined;
</script>
